export default {
  "Snackbar.Success": "登録を受付けました",
  "Snackbar.Error":
    "サーバーとの通信に失敗しているため、ページが表示できません\n恐れ入りますが、時間をおいてから再度お試しください\nしばらくたっても解決しない場合は、ビジネスｄアカウントサイトのメンテナンス情報をご確認ください",
  "Snackbar.NotFound": "ページを見つけることができませんでした",
  "Snackbar.Logout": "ログアウトしました",
}
